<template>
    <div class="accordion leagueview" role="tablist" v-if="matchCounts > 0">
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button @click.stop block v-b-toggle="'accordion-'+leagueKey + ((isLive)? '-live' : '')" class="font-bold">
                    <font-awesome-icon class="collapse-down" icon="fa-solid fa-angle-down"/>
                    <font-awesome-icon class="collapse-up" icon="fa-solid fa-angle-up"/>
                    {{translate('tournaments', leagueName, language)}}
                    <span :class="'badge badge-' + ((isLive)? 'danger' : 'primary')">{{matchCounts}}</span>
                    <button class="btn btn-link refresh" v-on:click.stop="refreshFeed">
                        <font-awesome-icon icon="fa-solid fa-arrow-rotate-right"/>
                    </button>
                </b-button>
            </b-card-header>
            <b-collapse :id="'accordion-'+leagueKey + ((isLive)? '-live' : '')" visible :accordion="leagueKey + ((isLive)? '-live' : '')" role="tabpanel">
                <b-card-body>
                    <div class="loading" v-show="hackedProgressBarValue < 100" style="width: 75%; padding: 0 0px 8px 25%;">
                        <b-progress :value="hackedProgressBarValue" variant="info" striped :animated="true" class="mt-2"></b-progress>
                    </div>
                    <MatchView
                            v-show="hackedProgressBarValue >= 100"
                            v-for="(match, id) in feed"
                            :key="id"
                            :match="match"
                            :league-key="leagueKey"
                            :match-info="match.matchInfo"
                            :matchId="parseInt(id)"
                    />
                </b-card-body>
            </b-collapse>
        </b-card>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import MatchView from "./MatchView";

    export default {
        name: 'LeagueViewBlock',
        components: {
            MatchView
        },
        props:{
            feed : Object,
            leagueName : String,
            leagueKey : String,
            isLive : Boolean,
            matchCounts : Number,
        },
        data() {
            return {
                hackedProgressBarValue : 100,
            }
        },
        computed: {
            ...mapGetters({
                language: 'settings/language',
            })
        },
        methods: {
            refreshFeed() {
                this.hackedProgressBarValue = 0
                this.hackProgressBar()
                this.$emit('refreshFeed')
            },
            hackProgressBar() {
                let timer = setInterval(() => {
                    this.hackedProgressBarValue += 6;
                    if (this.hackedProgressBarValue >= 100) clearInterval(timer);
                }, 20);
            }
        },
    }
</script>